
import ItemsAddToCartPWPComponent from '@/components/pwp/item-add-to-cart-pwp.vue'
export default {
  name: 'ProductResult',
  components: {
    'item-add-to-cart-pwp': ItemsAddToCartPWPComponent,
  },
  props: {
    filters: { type: Object, default: () => {} },
    view: { type: String, default: 'grid' },
    items: { type: Array, default: () => [] },
    listName: { type: String, default: '' },
    queryIdEventAlgolia: { type: String, default: '' },
    triggerEventAlgolia: { type: String, default: '' },
    indexEventAlgolia: { type: String, default: null },
    page: { type: Number, default: 0 },
    pageSize: { type: Number, default: 0 },
    // showFlashSale: { type: Boolean, default: false },
    // showOthers: { type: Boolean, default: true },
    gtmItemListId: { type: String, default: '' },
    gtmItemListName: { type: String, default: '' },
    // overlayImages: { type: Array, default: () => [] },
    isFullPWPQty: { type: Boolean, default: false },
    isPWPPage: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
  watch: {
    // items: {
    //   handler: function (val) {
    //     if (val.length) this.onGetOverlay()
    //   },
    //   deep: true,
    // },
  },
  methods: {
    positionOnPage(index) {
      return this.$eventInsightsAlgolia.calculatePositionAlgolia(
        index,
        this.page,
        this.pageSize
      )
    },
    // onGetOverlay() {
    //   // call api
    //   const itemsOverlay = [
    //     {
    //       id: '1009868',
    //       img: 'https://ofm-cdn0.ofm.co.th/images/logo/ofm-logo.png',
    //     },
    //     {
    //       id: '1091645',
    //       img: 'https://ofm-cdn0.ofm.co.th/images/logo/ofm-logo.png',
    //     },
    //   ]
    //   //emit image over to item-add-to-cart
    //   this.$nuxt.$emit('productOverlay', itemsOverlay)
    // },
  },
}
